import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasError: false,
            error: null,
            errorInfo: null,
            timeout: 5
        };

        
        this.countdownTimer = null;

        this.reloadToMainPage = this.reloadToMainPage.bind(this);
        this.timeoutHandler = this.timeoutHandler.bind(this);
    }

    reloadToMainPage() {
        this.setState({
            timeout: this.state.timeout - 1
        })

        if(this.state.timeout === 1) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
            window.location.assign(window.location.origin);
        }
    }

    timeoutHandler() {
        this.setState({
            timeout: this.state.timeout - 1
        })

        if(this.state.timeout === 1) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
            window.location.reload();
        }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({error: error});
        this.setState({errorInfo: errorInfo});
        this.setState({hasError: true});

        if (this.countdownTimer === null) {
            this.countdownTimer = setInterval(this.timeoutHandler, 1000);
        }
    }

    componentWillUnmount() {
        if(this.countdownTimer) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="container-sm text-align-center">
                    <h1>Something went wrong.</h1>
                    <p>An error has occurred. Page refresh in {this.state.timeout} seconds.</p>
                </div>
            )
        }

        return this.props.children;
    }
}

export default ErrorBoundary;